import styled from 'styled-components';

export const Container = styled.div`
  form {
    width: 100%;

    .inputContainer {
      background: #ffffff;
      color: #666360;

      height: 48px;
      border-radius: 10px;

      width: 100%;
      display: flex;
      align-items: center;
    }

    label[for='code_order_recharge'] {
      font-size: 18px;
    }

    .buttonsContainer {
      display: flex;
      justify-content: flex-end;
    }
  }
`;
